import React, {useState,useEffect} from 'react';
import { useTranslate } from 'react-redux-multilingual'
import { ColumDataTableReorganize,useLocalStorage} from "@gull";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFolder, faEye } from '@fortawesome/free-solid-svg-icons'
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import {scrollXDataTable} from 'app/scrollXDataTable';
import filterFactory, { textFilter } from 'react-bootstrap-table2-filter';
import Moment from 'react-moment';
import overlayFactory from 'react-bootstrap-table2-overlay';
import {Link} from 'react-router-dom'

const CustomDataTable = (props) => {
    const t = useTranslate();
    
    useEffect(() => {
        scrollXDataTable(window.screen.width,props.columns.length)
    }, [window.screen.width,props.columns.length]);

    const loadingOverlay = overlayFactory({
        spinner: true,
        text: t('cours_chargement')+'...',
    });
    
    return (
        <BootstrapTable
            {...props.propst.baseProps}
            bootstrap4
            pagination={paginationFactory(props.paginationOptions)}
            noDataIndication={t('tableNoData')}
            defaultSorted={props.defaultSorted}
            defaultSortDirection={props.defaultSortDirection}
            rowStyle={ props.rowStyle }
            hover
            condensed
            responsive
            filter={filterFactory()}
            overlay={loadingOverlay}
            loading={(props.loading) ? true : false}
        />
    );
};

const FolderList = (props) => {
    const t = useTranslate();
    let { SearchBar } = Search;
    const [perPage,setPerPage]=useState(50)
    const [localStorage, setLocalStorage] = useLocalStorage(['dossier_client_table_reorganize']);
    const [columnOrganize,setColumnOrganize]=useState([])
    const [showColumnOrganize,setShowColumnOrganize]=useState(false) 
    const [folderList,setFolderList] = useState([])
    const [filterState,setFilterState] = useState('open')

    let current_date = new Date()
    let timestampdate = current_date.setDate(current_date.getDate() + 90)
    let expire_date = new Date(timestampdate)

    useEffect(() => {
        let datas = props.folders.map(({id,name,nbr,company,other_company,client,status,created_at},ind) => ({
            id,
            name:<><FontAwesomeIcon icon={faFolder} /> {name}</>,
            nbr,
            client:(client.firstname) ? <Link to={"/invoice/client/detail/"+client.id} className="w-40 w-sm-100">{client.name+' '+client.firstname}</Link> : <Link to={"/invoice/client/detail/"+client.id} className="w-40 w-sm-100">{client.name}</Link>,
            company:(!other_company) ? company.name : other_company.name,
            status: (status!=0) ? t('finalized') : t('open'),
            status_brute: status,
            created_at,
            action:<FontAwesomeIcon icon={faEye} style={{cursor:'Pointer', color:'#FF8919'}} onClick={() => props.openFolder(id)}/>,
            index: ind + 1,
        }))

        if(props.filterStateActive && filterState=='open') {//si jamais le filtre state est actif et qu'on est sur le filtre de seulement les dossiers ouverts
            datas = datas.filter(value=>value.status_brute==0)
        }

        setFolderList(datas);

    }, [props.folders,filterState]);

    let defaultSorted = [
        {
          dataField: "created_at",
          order: "desc"
        }
    ];

    let columns = [
        {
            dataField: "action",
            text: "Actions",
            editable: false,
            headerClasses: 'head-action-row',
            classes: 'body-action-row',
        },
        {
            dataField: "name",
            text: t('name'),
            editable: false,
            sort:true,
            filter: textFilter({
                placeholder: 'Rechercher...',
                style: { width: '100%' },
                className: 'form-control-sm'
            })
        },
        {
            dataField: "nbr",
            text: t('number'),
            editable: false,
            sort:true,
            filter: textFilter({
                placeholder: 'Rechercher...',
                style: { width: '100%' },
                className: 'form-control-sm'
            })
        },
        {
            dataField: "client",
            text: t('client'),
            editable: false,
            sort:true,
        },
        {
            dataField: "company",
            text: t('company'),
            editable: false,
            sort:true,
        },
        {
            dataField: "status",
            text: t('state'),
            editable: false,
            sort:true,
        },
        {
            dataField: "created_at",
            text: t('created_at'),
            editable: false,
            sort:true,
            formatter: (cell) => <Moment format="DD/MM/YYYY">{cell}</Moment>,
            sortValue: (cell) => new Date(cell).getTime()
        },
    ];

     useEffect(function () {
        let columnCookie
        let arrCol = []
            
        if(localStorage.dossier_client_table_reorganize){
            let newValueToIncludeInCookie
            let cookieLecture = localStorage.dossier_client_table_reorganize.split(',')

            let already_done=[];
            cookieLecture.map(value=>{
                columns.map(item=>{
                    if(item.dataField==value){
                        arrCol.push(item)
                        already_done.push(value);
                    }
                })
            })
            columns.map(item=>{
                if(!already_done.includes(item.dataField)){ 
                    //si une nouvelle à été ajouté aux customsField, elle n'est pas ajoutée desuite au cookie de reorganisation si celui ci existe
                    //dans le cas où il n'existerait pas, on va créer un nouveau cookie afin de l'inclure pour ne pas avoir d'erreur sur les export 
                    newValueToIncludeInCookie=true
                    arrCol.push(item);
                }
            })

            columnCookie = arrCol
            if(newValueToIncludeInCookie==true){ 
                let arr = []
                arrCol.map(value=>
                    arr.push(value.dataField)
                )
                setLocalStorage("dossier_client_table_reorganize",arr.join(),{ path: "/", expires: expire_date })
            }
        }else{
            columnCookie = columns
        } 
        setColumnOrganize(columnCookie)
    }, [])

    const sizePerPageOptionRenderer = ({
        text,
        page,
        onSizePerPageChange
    }) => (
        <li
            key={ text }
            role="presentation"
            className="dropdown-item"
            onMouseDown={ (e) => {
                e.preventDefault();
                onSizePerPageChange(page);
                setPerPage(page)
            } }
        >
            <a
                href="#"
                tabIndex="-1"
                role="menuitem"
                data-page={ page }
                style={ { color: 'black' } }
            >
                { text }
            </a>
        </li>
    );

    let paginationOptions = {
        paginationSize: 5,
        pageStartIndex: 1,
        firstPageText: t('tableFirst'),
        prePageText: t('tableBack'),
        nextPageText: t('tableNext'),
        lastPageText: t('tableLast'),
        nextPageTitle: t('tableNextTitle'),
        prePageTitle: t('tableBackTitle'),
        firstPageTitle: t('tableFistTitle'),
        lastPageTitle: t('tableLastTitle'),
        sizePerPageOptionRenderer,
        sizePerPage: perPage,
        showTotal: true,
        totalSize: folderList.length,
    };

    const rowStyle = (t) => (row) => {
        const style = {};
        if (row.status === t('finalized')) style.backgroundColor = '#d9fcd2';
        
        return style;
    };

    const handleChangeFilerState = (e) => {//on set le filtre et on relance le useEffect
        setFilterState(e.target.value)
    }

    return(<>
        {columnOrganize.length!=0 &&
            <small>
                <ToolkitProvider
                striped
                keyField="index"
                data={folderList}
                columns={columnOrganize}
                search
                >
                {(propst) => (
                    <>
                        <div className="d-flex justify-content-between">
                            <div>
                                <ColumDataTableReorganize 
                                    columnOrganize={columnOrganize}
                                    setColumnOrganize={setColumnOrganize}
                                    setCookie={setLocalStorage}
                                    cookieName='dossier_client_table_reorganize'
                                    showColumnOrganize={showColumnOrganize}
                                    setShowColumnOrganize={setShowColumnOrganize}
                                    btnSwitch={false}//pour affiche ou non le btn swith
                                    initSwith={true}//initialier à false il affichera par défaut le toggle des colonnes, sur true il affichera le drag and drop pour changer la position des colonnes
                                />
                            </div>
                            <div className="d-flex justify-content-end align-items-center">
                                <span className="mb-2 me-1">{t('tableSearch')}:</span>
                                <SearchBar {...propst.searchProps} className="mb-2" />
                            </div>
                        </div>
                        {(props.filterStateActive) && //uniquement si on veut pouvoir filtrer sur l'état
                            <div className='row mb-3'>
                                <div className="col-6">
                                    <select className='form-control' onChange={(e) => handleChangeFilerState(e)}>
                                        <option value="open">Uniquement les dossiers ouverts</option>
                                        <option value="all">Tous les dossiers</option>
                                    </select>
                                </div>
                            </div>
                        }
                        <div className="position-relative">
                            <CustomDataTable 
                                propst={propst}
                                paginationOptions={paginationOptions}
                                defaultSorted={defaultSorted}
                                columns={columns}
                                defaultSortDirection="asc"
                                rowStyle={rowStyle(t)}
                                loading={props.loading}                            />
                        </div>
                    </>
                )}
                </ToolkitProvider>
            </small>
        }
    </>)
}

export default FolderList;